<template>
  <ul class="m-breadcrumb">
    <slot></slot>
  </ul>
</template>
<script>
export default {
  name: 'm-breadcrumb',
  props: {
    separator: {
      type: String,
      default: '/'
    }
  }
}
</script>
